import api from './api';

export const getDashboardStats = async () => {
    try {
        const response = await api.get('/api/dashboard/stats/');
        return response.data;
    } catch (error) {
        console.error('Error in getDashboardStats:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        return {
            total_users: 0,
            total_service_orders: 0,
            total_equipment: 0,
            total_consumables: 0,
            recent_activities: []
        };
    }
};

export const getRecentServiceOrders = async () => {
    try {
        const response = await api.get('/service-orders/?limit=5');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getLowStockItems = async () => {
    try {
        const response = await api.get('/api/inventory/consumables/low-stock/');
        return Array.isArray(response.data) ? response.data : response.data?.results || [];
    } catch (error) {
        throw error;
    }
}; 